import SidebarLayout from "@/Components/SideBar/SidebarLayout";
import PrivateRouteWrapper from "@/Components/Wrappers/PrivateRouteWrapper";
import Auth from "@/modules/Login/AuthPage";
import IfscMasterPage from "@/Pages/IfscMaster/IfscMasterPage";
import { lazy } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
const ExamListingPage = lazy(() => import("@/modules/ExamListing/ExamListingPage"));
const ExamQuestionPage = lazy(() => import("@/modules/ExamQuestions/ExamQuestionPage"));
const ErrorBoundary = lazy(() => import("../hoc/ErrorBoundary"));

const AgentMasterPageLazy = lazy(
  () => import("../Pages/AgentMaster/AgentMasterPage")
);
const TransactionMasterPageLazy = lazy(
  () => import("../Pages/TransactionMaster/TransactionMasterPage")
);
const PincodeMasterPageLazy = lazy(
  () => import("../Pages/PincodeMaster/PincodeMasterPage")
);

const EndorsementPage = lazy(
  () => import("../modules/Servicing-Module/Pages/Endorsement/EndorsementPage")
);
const StatusTrackingPage = lazy(
  () =>
    import(
      "../modules/Servicing-Module/Pages/StatusTracking/StatusTrackingPage"
    )
);
const RegisterRequestPage = lazy(
  () =>
    import(
      "../modules/Servicing-Module/Pages/RegisterRequest/RegisterRequestPage"
    )
);
const RoleMasterIndex = lazy(
  () => import("../modules/RoleMaster/RoleMasterIndex")
);
const AccessControlIndex = lazy(
  () => import("../modules/Access-Control/AccessControlIndex")
);
const CreateUserIndex = lazy(
  () => import("../modules/Create-User/CreateUserIndex")
);
const DiscrepancyListPageLazy = lazy(
  () => import("../Pages/DiscrepancyList/DiscrepancyListPage")
);

const ThemeIndex = lazy(() => import("../modules/Theme/ThemeIndex"));
const ReportIndex = lazy(() => import("../modules/IRDAI-Report/ReportIndex"));
const BulkUploadIndex = lazy(
  () => import("../modules/Payment-Bulk-Upload/BulkUploadIndex")
);
const MenuMasterIndex = lazy(
  () => import("../modules/Menu-Master/MenuMasterIndex")
);

const AgentBulkUpload = lazy(() => import("../modules/AgentBulkUpload/index"));
const LeadUploadIndex = lazy(
  () => import("../modules/Lead-Bulk-Upload/LeadUploadIndex")
);
const UpdateComponent = lazy(
  () => import("../modules/Admin-Approval/UpdateComponent")
);

const EventIndex = lazy(() => import("../modules/Event-Master/EventIndex"));
const RoleBasedCharges = lazy(
  () => import("../modules/Role-BasedCharges/RoleBasedCharges")
);

const NotFound = lazy(() => import("../Components/NotFound/NotFound"));

const ExamDateBulkIndex = lazy(
  () => import("../modules/ExamBulkUpload/ExamBulkIndex")
);

const ExamResultBulkIndex = lazy(
  () => import("../modules/ExamResultBulkUpload/ExamResultBulkIndex")
);

const ExamQuestionsIndex = lazy(
  () => import("../modules/Exam-Questions-Upload/ExamQuestionsIndex")
);

const ExamConfigListing = lazy(
  () => import("../modules/Exam-Config/Components/ExamConfigListing")
);

const AgentMenuMasterIndex = lazy(
  () => import("../modules/AgentMenuMaster/AgentMenuMasterIndex")
);

const ServerDown = lazy(
  () => import("../Components/MaintainancePage/ServerDown")
);

const UrlConfigIndex = lazy(
  () => import("../modules/UrlConfig/UrlConfigIndex")
);

const UtilityMasterIndex = lazy(
  () => import("../modules/UtilityMaster/UtilityMasterIndex")
);
const PendingExamShows = lazy(
  () => import("../modules/PendingExamShows/PendingExamShows")
);
const PaymentWayOfLazyPage = lazy(
  () => import("../modules/PaymentWayOf/PaymentWayOfPage")
);
const ServicingLazyComponent = lazy(
  () => import("../modules/Servicing-Module/ServicingModule")
);
const BlackListingAgentPage = lazy(
  () => import("@/modules/BlackListingAgents/BlackListingAgentPage")
);

const PaymentReceiptPage = lazy(
  () => import("@/modules/PaymentReciept/PaymentRecieptPage")
);
const RescheduleRaisePage = lazy(
  () => import("@/modules/RescheduleRaise/RescheduleRaisePage")
);
const RescheduleApproveListingPage = lazy(
  () => import("@/modules/RescheduleApproveModule/RescheduleApproveListingPage")
);
const RescheduleExamPage = lazy(
  () => import("@/modules/RescheduleExam/RescheduleExamPage")
);
const RescheduleExamListingPage = lazy(
  () => import("@/modules/RescheduleExamListing/RescheduleExamListingPage")
);
const EditRescheduleExamDetails = lazy(
  () => import("@/modules/RescheduleExam/component/EditRescheduleExamDetails")
);
const ApproveRescheduleExamDetails = lazy(
  () =>
    import("@/modules/RescheduleRaise/component/ApproveRescheduleExamDetails")
);

const AgingDiscrepancyPage = lazy(
  () => import("@/modules/AgingDiscrepancy/AgingDiscrepancyPage")
);

const OperationServicingModulePage = lazy(
  () =>
    import("../modules/OperationServicingModule/OperationServicingModulePage")
);

const TrainingMasterPageLazy = lazy(
  () => import("../Pages/TrainingMaster/TrainingMasterPage")
);
const NocListingPageLazy = lazy(
  () => import("../Pages/NocListing/NocListingPage")
);

const AgentJourneyWrapperLazy = lazy(
  () => import("../Pages/AgentJourney/AgentJourneyWrapper")
);

const ProfileDetailsFormLazy = lazy(
  () => import("../shared/forms/ProfileDetails/ProfileDetailsForm")
);

const BankDetailFormLazy = lazy(
  () => import("../shared/forms/BankDetails/BankDetailForm")
);

const NomineeDetailsFormLazy = lazy(
  () => import("../shared/forms/NomineeDetails/NomineeDetailsForm")
);

const DocumentDetailsFormLazy = lazy(
  () => import("../shared/forms/DocumentDetails/DocumentDetailsForm")
);

const ConsentFormLazy = lazy(
  () => import("../shared/forms/Consent/ConsentForm")
);

const PaymentFormLazy = lazy(
  () => import("../shared/forms/Payment/PaymentForm")
);

const ExamDetailFormPageLazy = lazy(
  () => import("../shared/forms/ExamDetails/ExamDetailForm")
);

const router = createBrowserRouter(
  [
    {
      path: "/login",
      element: <Auth />,
      errorElement: <ErrorBoundary />,
    },
    {
      element: <PrivateRouteWrapper />,
      children: [
        {
          path: "/",
          element: <SidebarLayout />,
          children: [
            {
              index: true,
              element: <Navigate to="/agent-master" replace={true} />,
            },
            {
              path: "/role-master",
              element: <RoleMasterIndex />,
            },
            {
              path: "/servicing-module",
              element: <ServicingLazyComponent />,
              children: [
                {
                  index: true,
                  element: <Navigate to="endorsement" replace />,
                },
                {
                  path: "endorsement",
                  element: <EndorsementPage />,
                  // verticalId === 1 || verticalId === 2 ? (
                  //   <Navigate to="status-tracking" replace />
                  // ) : (
                  //   <EndorsementPage />
                  // ),
                },
                {
                  path: "status-tracking",
                  element: <StatusTrackingPage />,
                },

                {
                  path: "register-request/:id",
                  element: <RegisterRequestPage />,
                },
              ],
            },
            {
              path: "status-tracking-actionable",
              element: <OperationServicingModulePage />,
            },
            {
              path: "status-tracking-non-actionable",
              element: <OperationServicingModulePage />,
            },
            {
              path: "/access-control",
              element: <AccessControlIndex />,
            },
            {
              path: "/agent-master",
              element: <AgentMasterPageLazy />,
            },
            {
              path: "/agent-master/:id",
              element: <UpdateComponent />,
            },
            {
              path: "/create-user",
              element: <CreateUserIndex />,
            },
            {
              path: "/transaction-master",
              element: <TransactionMasterPageLazy />,
            },
            {
              path: "/training-master",
              element: <TrainingMasterPageLazy />,
            },
            {
              path: "/discrepancy-listing",
              element: <DiscrepancyListPageLazy />,
            },
            {
              path: "/pincode-master",
              element: <PincodeMasterPageLazy />,
            },
            {
              path: "/reschedule-raise",
              element: <RescheduleRaisePage />,
            },
            {
              path: "/reschedule-approve",
              element: <RescheduleApproveListingPage />,
            },
            {
              path: "/reschedule-exam",
              element: <RescheduleExamPage />,
            },
            {
              path: "/reschedule-listing",
              element: <RescheduleExamListingPage />,
            },
            {
              path: "/reschedule-exam/:id",
              element: <EditRescheduleExamDetails />,
            },
            {
              path: "/reschedule-raise/:id",
              element: <ApproveRescheduleExamDetails />,
            },
            {
              path: "/theme",
              element: <ThemeIndex />,
            },
            {
              path: "/irdai-report",
              element: <ReportIndex />,
            },
            {
              path: "/ifsc-master",
              element: <IfscMasterPage />,
            },
            {
              path: "/bulk-upload",
              element: <BulkUploadIndex />,
            },
            {
              path: "/menu-master",
              element: <MenuMasterIndex />,
            },
            {
              path: "/role-based-charges",
              element: <RoleBasedCharges />,
            },
            {
              path: "/payment-waiver",
              element: <PaymentWayOfLazyPage />,
            },
            {
              path: "/agent-bulk-upload",
              element: <AgentBulkUpload />,
            },

            // {
            //   path: "/document-upload",
            //   element: <DocumentUploadIndex />,
            // },
            // {
            //   path: "/branch-onboarding",
            //   element: <BranchIndex />,
            // },
            {
              path: "/lead-upload",
              element: <LeadUploadIndex />,
            },
            {
              path: "/event-master",
              element: <EventIndex />,
            },
            // {
            //   path: "/pos-bulk-upload",
            //   element: <POSIndex />,
            // },
            // {
            //   path: "/sp-bulk-upload",
            //   element: <SPIndex />,
            // },
            // {
            //   path: "/av-bulk-upload",
            //   element: <AVIndex />,
            // },
            {
              path: "/noc",
              element: <NocListingPageLazy />,
            },
            {
              path: "/exam-date-bulk-upload",
              element: <ExamDateBulkIndex />,
            },
            {
              path: "/exam-result-bulk-upload",
              element: <ExamResultBulkIndex />,
            },
            // {
            //   path: "/exam-config",
            //   element: <ExamConfigIndex />,
            // },
            {
              path: "/exam-config-listing",
              element: <ExamListingPage />,
            },
            {
              path: "/exam-questions",
              // element: <ExamQuestionsIndex />,
              element: <ExamQuestionPage />,
            },
            {
              path: "/agent-menu-master",
              element: <AgentMenuMasterIndex />,
            },
            {
              path: "/url-config",
              element: <UrlConfigIndex />,
            },
            {
              path: "/utility-master",
              element: <UtilityMasterIndex />,
            },
            {
              path: "/exam-pending",
              element: <PendingExamShows />,
            },
            {
              path: "/blacklisted-agents",
              element: <BlackListingAgentPage />,
            },
            {
              path: "/payment-receipt-master",
              element: <PaymentReceiptPage />,
            },
            {
              path: "/aging-descrepancy",
              element: <AgingDiscrepancyPage />,
            },
          ],
        },
      ],
    },
    {
      element: <PrivateRouteWrapper />,
      children: [
        {
          path: "/agent",
          element: <AgentJourneyWrapperLazy />,
          children: [
            {
              index: true,
              path: "profile-details",
              element: <ProfileDetailsFormLazy />,
            },
            {
              path: "bank-details",
              element: <BankDetailFormLazy />,
            },
            {
              path: "nominee-details",
              element: <NomineeDetailsFormLazy />,
            },
            {
              path: "documents",
              element: <DocumentDetailsFormLazy />,
            },
            {
              path: "consent",
              element: <ConsentFormLazy />,
            },
            {
              path: "payment",
              element: <PaymentFormLazy />,
            },
            {
              path: "exam-details",
              element: <ExamDetailFormPageLazy />,
            },
          ],
        },
      ],
    },
    {
      path: "*",
      element: <NotFound />,
    },
    {
      path: "/500",
      element: <ServerDown />,
    },
  ],
  { basename: import.meta.env.VITE_APP_BASE_PATH }
);

export default router;
